export enum LangType {
    FR = "FR",
    DE = "DE",
    UK = "UK",
    ES = "ES",
    IT = "IT",
    AT = "AT",
}

export type TLangType = keyof typeof LangType;
